/**
 * Ask's rows in ⌘K: "Ask Admin", which opens Ask where it lives (the panel
 * beside the page, or the composer of the Overview and `/ask`), and "New Ask
 * chat", which does the same with an empty thread. Pure, so the ids, words
 * and wiring are pinned without the shell.
 *
 * The ids are stable (`ask:admin`, `ask:new-chat`): the palette's Recent list
 * keys on them, so a language change keeps a recent row.
 */
import type { PaperAction } from '@ricoh-paper/angular/shell';

/** The rows' words, resolved in the active language. */
export interface SettingsAskActionLabels {
  /** "Ask Admin". */
  readonly ask: string;
  /** "New Ask chat". */
  readonly newChat: string;
  /** The palette group, "Ask". */
  readonly group: string;
}

/** What each row does, and whether the organisation has Ask at all. */
export interface SettingsAskActionRuns {
  readonly open: () => void;
  readonly newChat: () => void;
  /**
   * Ask is on for the organisation. "Ask Admin" shows either way (with Ask
   * off it opens the Overview, which says how to turn it on); "New Ask chat"
   * only with Ask on, as there is no chat to start otherwise.
   */
  readonly available: () => boolean;
}

export const ASK_ADMIN_ACTION_ID = 'ask:admin';
export const ASK_NEW_CHAT_ACTION_ID = 'ask:new-chat';

export function settingsAskActions(labels: SettingsAskActionLabels, run: SettingsAskActionRuns): PaperAction[] {
  return [
    {
      id: ASK_ADMIN_ACTION_ID,
      label: labels.ask,
      group: labels.group,
      icon: 'ask',
      keywords: ['ai', 'assistant', 'help', 'question'],
      suggested: true,
      run: () => run.open(),
    },
    {
      id: ASK_NEW_CHAT_ACTION_ID,
      label: labels.newChat,
      group: labels.group,
      icon: 'plus',
      keywords: ['new', 'chat', 'conversation', 'start over', 'clear', 'ask', 'ai', 'assistant'],
      visible: () => run.available(),
      run: () => run.newChat(),
    },
  ];
}
